import { Stack, styled, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PropertyGroup } from "src/context/Property/Builder/PropertyBuilder";
import { PropertyHeader, ValueSwitch } from "./ValueSwitch";
import { Fragment } from "react/jsx-runtime";

type GroupPropertyProps = {
    startProperty: PropertyGroup;
    endProperty: PropertyGroup;
};
export const GroupProperty = (props: GroupPropertyProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { startProperty, endProperty } = props;

    const startTitle = t("actionPlan.value_in_year", { year: startProperty.campaign?.label });
    const targetTitle = `${t("Goal")} ${endProperty.campaign?.label}`;

    const allChildren = endProperty.property.children;

    const childrenWhitelist = endProperty.property.actionChildrenIds ?? [];
    const isWhitelistActivated = childrenWhitelist.length > 0;
    return (
        <Stack gap={theme.spacing(2)}>
            <PropertyHeader startTitle={startTitle} targetTitle={targetTitle} />
            {allChildren?.flatMap((childProperty, idx) => {
                const shouldShow = isWhitelistActivated === false ? true : childrenWhitelist.includes(childProperty.id);

                if (shouldShow === false) {
                    return [];
                }

                const foundStarting = startProperty.content.find((elem) => elem.property.id === childProperty.id);
                const foundTarget = endProperty.content.find((elem) => elem.property.id === childProperty.id);
                return [
                    <Stack key={`${idx}-group`} flexDirection={"row"}>
                        <CenteredStack borderRight={`1px solid ${theme.custom.grey[1400]}`} gap={theme.spacing(0.5)}>
                            <Fragment>
                                <ValueSwitch
                                    property={foundStarting}
                                    title={foundStarting?.property.title}
                                    variant="readonly"
                                />
                            </Fragment>
                        </CenteredStack>
                        <CenteredStack>
                            <ValueSwitch property={foundTarget} title={foundTarget?.property.title} />
                        </CenteredStack>
                    </Stack>,
                ];
            })}
        </Stack>
    );
};

const CenteredStack = styled(Stack)(({ theme }) => ({
    width: "50%",
    justifyContent: "center",
    alignItems: "start",
    paddingLeft: theme.spacing(2),
}));
